export const colorCode = {
    "lightblue":"#3b82f6",
    "lightGreen": "#22c55e",
    "oceanBlu": "#93c5fd"
    
}